var iwp_looks_default = (() => {
    if (customElements.get("iwp-looks")) return;
    class IwpLooks extends HTMLElement {
        overlay=this.querySelector("[data-iwp-look-overlay]");
        closeButton=this.querySelector("[data-iwp-look-close]");
        media=this.querySelector(".iwp__look-media");
        observer=null;
        armed=true;
        constructor() {
            super();
            this.handleIntersect = this.handleIntersect.bind(this);
            this.handleToggle = this.handleToggle.bind(this);
        }
        handleIntersect(entries) {
            entries.forEach(entry => {
                if (!this.armed) return;
                if (entry.isIntersecting) this.classList.add("is-visible"); else this.classList.remove("is-visible");
            });
        }
        handleToggle() {
            const collapsed = this.classList.toggle("is-collapsed");
            if (collapsed) {
                this.classList.remove("is-visible");
                this.armed = false;
            } else {
                this.armed = true;
                this.classList.add("is-visible");
            }
            this.updateCloseAria(collapsed);
        }
        updateCloseAria(collapsed) {
            if (!this.closeButton) return;
            this.closeButton.setAttribute("aria-expanded", collapsed ? "false" : "true");
            const strings = window.MBF?.strings?.general;
            const label = collapsed ? strings?.viewProducts : strings?.close;
            if (label) this.closeButton.setAttribute("aria-label", label);
        }
        setupIntersectionObserver() {
            const target = this.media || this.overlay || this;
            if (!target) return;
            this.observer = new IntersectionObserver(this.handleIntersect, {
                root: null,
                rootMargin: "0px 0px 0px 0px",
                threshold: .85
            });
            this.observer.observe(target);
        }
        connectedCallback() {
            if (!this.overlay) return;
            this.closeButton?.addEventListener("click", this.handleToggle);
            this.setupIntersectionObserver();
        }
        disconnectedCallback() {
            this.observer?.disconnect();
            this.observer = null;
            this.closeButton?.removeEventListener("click", this.handleToggle);
        }
    }
    customElements.define("iwp-looks", IwpLooks);
})();